module.exports = __webpack_public_path__ + "../front/img/568_med_5hylder.101ac38c.svg";